/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { useRouter } from 'next/navigation'
import { FeaturedBrand } from "@/types/General";

interface HomeFestiveProps {
  items: FeaturedBrand[];
}

function HomeFestive({ items }: HomeFestiveProps) {
  const router = useRouter();

  if (!items || items.length === 0) {
    return null; // Don't render if no items are provided
  }

  return (
    <>
      <section className="home_festive_sc">
        <div className="container">
          <div className="s_head text_center">
            <h2>
              <span className="f_Playball">Festival</span>
              <strong className='f_Jost'>Of INDIA</strong>
            </h2>
          </div>

          <div className="festive_grid gap_m">
            {items.map((item, index) => (
              <div
                key={index}
                className="festive_item"
                onClick={() => {
                  const hasAllKeys = item?.banner_links?.every(
                    (link) => link?.linkable_id && link?.linkable_type && link?.type
                  );

                  if (hasAllKeys) {
                    if (item?.type === "brand") {
                      router.push(
                        `/product/product-category?brandIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else if (item.type === "category") {
                      router.push(
                        `/product/product-category?categoryIds=${item?.id}&type=featured_brands`
                      );
                    } else if (item.type === "product") {
                      router.push(
                        `/product/product-category?productIds=${item?.banner_links
                          ?.map((link) => link?.linkable_id)
                          .join(",")}`
                      );
                    } else {
                      router.push("/product/product-category?type=recommended");
                    }
                  } else {
                    router.push("/product/product-category?type=recommended");
                  }
                }}
              >
                  <img src={item.image} alt={item.title || "Festive Image"} />
                {/* <p>{item.title}</p> */}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeFestive